import React, { useEffect } from 'react';

const AdComponent = () => {
  useEffect(() => {
    // Load the AdSense script
    const script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7387649925166955';
    script.async = true;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);

    // Initialize the ad
    script.onload = () => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    };

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
        <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-7387649925166955"
            data-ad-slot="6324930573"
            data-ad-format="auto"
            data-full-width-responsive="true"
        />
        <label style={{
            display: 'block',
            margin: '0px auto',
            width: 'fit-content',
            letterSpacing: '4px',
            color: 'rgb(65, 77, 101)',
            font: '400 9px/2 Arial, sans-serif',
            opacity: 0.7
        }}  className='text-center pb-2'>Advertisement</label>
    </>
  );
};
export default AdComponent